// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__qz2W7","heading":"Footer_heading__83OUt","content":"Footer_content__MncDC","details":"Footer_details__XK+wC"};